module.exports = __webpack_public_path__ + "img/icon_chip_01.5da6cb50.png";